/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/quantile_over_time.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the φ-quantile (0 ≤ φ ≤ 1) of the values in the specified time range.
 *
 * @example
 * quantile_over_time(0.5, http_requests_total[1h])
 */
const definition: PromqlFunctionDefinition = {
  type: 'within_series',
  name: 'quantile_over_time',
  signatures: [
    {
      params: [
        {
          name: 'φ',
          type: 'scalar',
          optional: false,
          description: 'Quantile value (0 ≤ φ ≤ 1).',
        },
        {
          name: 'v',
          type: 'range_vector',
          optional: false,
          description: 'Range vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
